/*
    This file contains global variables to be accessable in all ClientApp files.
*/

window.minAge = 18;
window.maxAge = 110;